import React from 'react';
import PropTypes from 'prop-types';
import Input from '@blaze-react/input';
import { MdSearch } from 'react-icons/md';
import { SEARCH_TERM } from '../constants';
const TextSearch = ({
  label,
  searchValue,
  updateFilterValues,
  elementTitle
}) => /*#__PURE__*/React.createElement(React.Fragment, null, elementTitle && /*#__PURE__*/React.createElement("div", {
  className: "heading heading--section"
}, elementTitle), /*#__PURE__*/React.createElement("div", {
  className: "search"
}, /*#__PURE__*/React.createElement("div", {
  className: "search__wrapper"
}, /*#__PURE__*/React.createElement("div", {
  className: "form-field form-field--input form-field--search"
}, /*#__PURE__*/React.createElement(Input, {
  id: SEARCH_TERM,
  value: searchValue,
  placeholder: label || 'Search',
  onChange: ({
    value: eValue
  }) => {
    updateFilterValues({
      [SEARCH_TERM]: eValue
    }, false);
  }
})), /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: "icon-button icon-button--search",
  "aria-label": "Search",
  onClick: e => {
    e.preventDefault();
    updateFilterValues({
      [SEARCH_TERM]: searchValue
    }, true);
  }
}, /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement(MdSearch, null))))));
TextSearch.propTypes = {
  searchValue: PropTypes.string.isRequired,
  updateFilterValues: PropTypes.func.isRequired,
  elementTitle: PropTypes.string,
  label: PropTypes.string
};
TextSearch.defaultProps = {
  elementTitle: '',
  label: ''
};
export default TextSearch;
//# sourceMappingURL=TextSearch.js.map